/**
 * Dashboard Layout Component
 *
 * Main layout with sidebar that wraps all dashboard routes
 */

import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { isPWA } from "../lib/platform";

export function DashboardLayout() {
  const isInPWA = isPWA();
  // Start with sidebar collapsed for webapp, closed for PWA
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen flex flex-col bg-[#FAF6F1] dark:bg-[#1A2D47]">
      {/* Fixed Header - Only for PWA */}
      {isInPWA && (
        <Header
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />
      )}

      {/* Content Area */}
      <div className={`flex flex-1 overflow-hidden ${isInPWA ? "pt-14" : ""}`}>
        <Sidebar
          isOpen={sidebarOpen}
          onToggle={() => setSidebarOpen(!sidebarOpen)}
        />

        {/* Main Content - Add left margin for webapp sidebar */}
        <main
          className={`flex-1 h-full overflow-hidden transition-all duration-300 ${
            isInPWA ? "" : sidebarOpen ? "ml-64" : "ml-16"
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
